// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-get-packers-movers-list',
//   templateUrl: './get-packers-movers-list.component.html',
//   styleUrls: ['./get-packers-movers-list.component.sass']
// })
// export class GetPackersMoversListComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

import { Component, OnInit } from "@angular/core";
import { PackersMoversService } from "../service/packers-movers.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-get-packers-movers-list",
  templateUrl: "./get-packers-movers-list.component.html",
  styleUrls: ["./get-packers-movers-list.component.sass"],
})
export class GetPackersMoversListComponent implements OnInit {
  allPackersMovers: any[] = [];
  page = 1;
  limit = 10;
  totalCount = 0;
  totalPages = 0;

  constructor(
    private packersMoversService: PackersMoversService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getPackersMoversList();
  }

  getPackersMoversList() {
    const body = {
      page: this.page,
      limit: this.limit,
    };

    this.packersMoversService.getPackersMoversList(body).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.allPackersMovers = response.data;
          this.totalCount = response.totalCount;
          this.totalPages = response.totalPages;
        }
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  changePage(page: number) {
    this.page = page;
    this.getPackersMoversList();
  }

  viewDetails(id: string) {
    this.router.navigate(["/dashboard/view-website-packers-movers"], {
      queryParams: { id },
    });
  }
}
